export const EResellerCommissionDurationType = {
  FixedMonths: 0,
  Recurring: 1,
} as const

export type EResellerCommissionDurationType =
  (typeof EResellerCommissionDurationType)[keyof typeof EResellerCommissionDurationType]
